import React, { Component } from "react";
import PropTypes from "prop-types";
import { getDistinctValues } from "../../../services/api-landscape";
import MultiSelect from "../../common/multi-select";
import { toUpper } from "lodash";

class VennMultiSelect extends Component {
  static propTypes = {
    width: PropTypes.string,
    defaultSets: PropTypes.array.isRequired,
    esUrl: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    value: PropTypes.array,
    version: PropTypes.string
  };

  static defaultProps = {
    width: "75%",
    placeholder: "Collections"
  };

  state = {
    loading: true,
    selectedCollections: this.props.value ? this.props.value : this.props.defaultSets ? this.props.defaultSets : []
  };

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const { width, placeholder } = this.props;
    return (
      <div>
        <MultiSelect
          value={this.state.selectedCollections}
          onChange={this._onChange}
          optionApiCall={val =>
            getDistinctValues(this.props.esUrl, this.props.version, "pools", {
              pools: val || ""
            })
          }
          optionRender={toUpper} // Makes all the options uppercase
          mode={"multiple"}
          placeholder={placeholder}
          disabled={false}
          style={{ width }}
        />
      </div>
    );
  }

  _onChange = value => {
    this.setState({ selectedCollections: value });
    this.props.onChange(value);
  };
}

export default VennMultiSelect;
